import { TFunction } from 'i18next';
import { z } from 'zod';

const NAME_WITH_SPACES_REGEX = /^[A-Za-z\s]*[A-Za-z][A-Za-z\s]*$/;

export const inviteMemberSchema = (t: TFunction) =>
  z.object({
    name: z
      .string({ required_error: t('name_is_required') })
      .trim()
      .min(2, t('minimum_2_character_required'))
      .max(64, 'Name must be less than or equal to 64 characters long.')
      .refine((s) => NAME_WITH_SPACES_REGEX.test(s.trim()), t('your_name_is_not_valid')),
    email: z
      .string({ required_error: t('email_is_required') })
      .trim()
      .email({ message: t('please_enter_a_valid_email_address') })
      .toLowerCase(),
    role: z.string({ required_error: t('role_is_required') }),
    terms: z
      .boolean()
      .optional()
      .refine((val) => val, { message: t('you_must_acknowledge_the_charge_by_checking_the_box') }),
  });

export const enterpriseSchema = z.object({
  enterpriseCode: z.string().min(8, 'Code must be 8 characters long').max(8, 'Code must be 8 characters long'),
});
